import { useTheme } from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import { SaveIncidentForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';

import { useParams } from 'react-router-dom';



export type SaveAccidentModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SaveAccidentModalProps) => {
  const params = useParams();
  const theme = useTheme();
  return (
    <BasicFormModalLayout.FC
      id={props.id}
      handleClose={props.handleClose}
      isVisible={props.isVisible}
      title='Accident'
      subTitle='Log Accident Information'
      headerIcon={(
        <CustomIcon.large.FC
          icon='ALERT'
          stroke={theme.palette.error.main}
        />
      )}
    >
      <SaveIncidentForm.FC
        id={props.id}
        projectId={params.projectId ?? ''}
        handleClose={props.handleClose}
      />

    </BasicFormModalLayout.FC>
  );
};
